// Make button in section "Saņemt jaunākos piedāvājumus!" in Home Screen Trigger theme's native popup system
document.addEventListener('DOMContentLoaded', function() {
    console.log('Native Popup Trigger loaded');
    
    const button = document.querySelector('#shopify-section-template--25820214133079__countdown-timer a');
    
    if (!button) {
        console.error('Button not found');
        return;
    }
    
    button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Finding native popup trigger...');
        
        // METHOD 1: Look for hidden trigger buttons
        const nativeTriggers = [
            // Common Shopify theme selectors
            '[data-modal-open="NewsletterModal"]',
            '[data-drawer-open="NewsletterModal"]',
            '[href="#NewsletterModal"]',
            '[data-target="#NewsletterModal"]',
            '[aria-controls="NewsletterModal"]',
            '.newsletter-trigger',
            '.popup-trigger'
        ];
        
        let foundTrigger = null;
        
        nativeTriggers.forEach(selector => {
            const trigger = document.querySelector(selector);
            if (trigger && !foundTrigger) {
                console.log('Found native trigger:', selector, trigger);
                foundTrigger = trigger;
            }
        });
        
        if (foundTrigger) {
            console.log('Clicking native trigger...');
            foundTrigger.click();
            return;
        }
        
        // METHOD 2: Check if theme has modal/drawer system
        if (window.theme) {
            console.log('Theme object found:', Object.keys(theme));
            
            if (theme.Modal) {
                console.log('Using theme.Modal system');
                const popup = document.getElementById('NewsletterModal');
                const modal = new theme.Modal(popup);
                modal.open();
                return;
            }
            
            if (theme.Drawer) {
                console.log('Using theme.Drawer system');
                const popup = document.getElementById('NewsletterModal');
                const drawer = new theme.Drawer(popup);
                drawer.open();
                return;
            }
        }
        
        // METHOD 3: Look for any element that controls this modal
        console.log('Searching for any element that controls NewsletterModal...');
        const allElements = document.querySelectorAll('[id], [class], [data-*]');
        allElements.forEach(el => {
            const attrs = Array.from(el.attributes);
            attrs.forEach(attr => {
                if (attr.value && attr.value.includes('NewsletterModal')) {
                    console.log('Potential trigger found:', el, attr.name, attr.value);
                }
            });
        });
        
        console.warn('No native trigger found - check console for potential triggers');
    });
});